/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsReferences
 */
export interface SharedserviceMelcoModelsReferences {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsReferences
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsReferences
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsReferences
     */
    parent_id: string;
}

export function SharedserviceMelcoModelsReferencesFromJSON(json: any): SharedserviceMelcoModelsReferences {
    return SharedserviceMelcoModelsReferencesFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsReferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsReferences {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'parent_id': json['parent_id'],
    };
}

export function SharedserviceMelcoModelsReferencesToJSON(value?: SharedserviceMelcoModelsReferences | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'parent_id': value.parent_id,
    };
}


